import React, { useEffect, useState } from 'react';
import { Box, Container, HStack, Text, Button } from '@chakra-ui/react';
import { Phone } from 'lucide-react';
interface StickyTopBarProps {
  whatsappUrl: string;
}
export function StickyTopBar({
  whatsappUrl
}: StickyTopBarProps) {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show bar after scrolling 800px (approximately after second section)
      if (window.scrollY > 800) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleClick = () => {
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };
  if (!isVisible) return null;
  return <Box position="fixed" top={0} left={0} right={0} zIndex={1001} bgGradient="linear(to-r, brand.600, brand.500, brand.600)" borderBottom="2px solid" borderColor="brand.400" backdropFilter="blur(20px)" boxShadow="0 4px 20px rgba(220, 38, 38, 0.6)" animation="slideDown 0.4s ease-out" sx={{
    '@keyframes slideDown': {
      from: {
        transform: 'translateY(-100%)',
        opacity: 0
      },
      to: {
        transform: 'translateY(0)',
        opacity: 1
      }
    }
  }} data-id="element-26">
      <Container maxW="container.xl" data-id="element-27">
        <HStack justify="space-between" py={3} spacing={4} data-id="element-28">
          <HStack spacing={3} data-id="element-29">
            <Box w="2px" h="20px" bg="brand.500" data-id="element-30" />
            <Text fontSize={{
            base: 'sm',
            md: 'md'
          }} color="white" fontWeight="semibold" data-id="element-31">
              Consultas limitadas disponibles
            </Text>
            <Box bg="brand.500" px={2} py={0.5} borderRadius="sm" display={{
            base: 'none',
            md: 'block'
          }} data-id="element-32">
              <Text fontSize="xs" color="white" fontWeight="bold" data-id="element-33">
                AHORA
              </Text>
            </Box>
          </HStack>

          <Button onClick={handleClick} size="sm" bg="#25D366" color="white" fontWeight="bold" textTransform="uppercase" fontSize="xs" px={6} leftIcon={<Phone size={16} data-id="element-35" />} _hover={{
          bg: '#20BA5A',
          transform: 'scale(1.05)'
        }} _active={{
          transform: 'scale(0.98)'
        }} transition="all 0.2s ease" data-id="element-34">
            Contactar
          </Button>
        </HStack>
      </Container>
    </Box>;
}